module.exports = __webpack_public_path__ + "assets/img/21972-312_SOC_NonCPA.66933e61.png";